///<reference path="../../../../typings/index.d.ts"/>
///<reference path="../models/meevo.model.custom.ts"/>
///<reference path="./select/select.component.ts"/>

module Meevo.Components.Controls {

    import IReportControl = Meevo.Model.IReportControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IMeevoReportSelectDirectiveScope extends angular.IScope {
        label?: string;
        options: IReportControl;
        model: any;
        layout?: string;
        defaultValue?: any;
        valueKey?: string;
        url?: string;
        requestData?: any;
        required: boolean;
        hideIfEmpty: boolean;
        mobileLayoutType: IMobileLayoutType;
    }

    const dataTemplate = {
        HighlightedProductCat: {
            url: 'Report/ProductCategory/List',
            valueKey: 'id',
            requestData: {
                criteria: {
                    businessTypeList: null,
                    locationList: null,
                    hierarchyId: null,
                    branchId: null,
                    objectStateEnumList: [ObjectStateEnum.Active],
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                },
                itemsPerPage: 50000
            },
        },
        HighlightedServiceCat: {
            url: 'Report/ServiceCategory/List',
            valueKey: 'id',
            requestData: {
                criteria: {
                    businessTypeList: null,
                    locationList: null,
                    hierarchyId: null,
                    branchId: null,
                    objectStateEnumList: [ObjectStateEnum.Active],
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                },
                itemsPerPage: 50000
            },
        },
        DepartmentServiceCategory: {
            url: 'Report/Department/List',
            valueKey: 'id',
            label: 'LABEL_DEPARTMENT',
            requestData: {
                criteria: {
                    businessTypeList: null,
                    locationList: null,
                    hierarchyId: null,
                    branchId: null,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                },
                itemsPerPage: 50000
            },
            required: false,
            allLabel: 'LABEL_ALL_DEPARTMENT',
            hideIfEmpty: true
        },
        SortReportByAQ150: {
            required: false
        },
        SortReportByDB001: {
            required: false
        },
        Departments_TBL: {
            url: 'Report/Department/List',
            valueKey: 'id',
            label: 'LABEL_DEPARTMENTS',
            requestData: {
                criteria: {
                    businessTypeList: null,
                    locationList: null,
                    hierarchyId: null,
                    branchId: null,
                    includeActive: true,
                    includeDeleted: false,
                    includeInactive: false,
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                },
                itemsPerPage: 50000
            },
            allLabel: 'LABEL_NONE',
            hideIfEmpty: true
        },
        NumberOfClientPerDay: {
            options: {
                values: _.range(0, 11).map((n) => ({
                    value: n,
                    displayName: n.toString() + (n === 0 ? '' : ' or fewer')
                }))
            }
        },
        SortReportByDE110: {
            defaultValue: 50114,
            valueKey: 'id'
        },
        SortReportByDE070: {
            defaultValue: 'Employee',
            valueKey: 'value',
            required: false
        },
        'RunForCOMR145': {
            valueKey: 'id'
        },
        'ClientVisitsDefinedAsNewToMA050': {
            required: false
        },
        'SortReportByMA050': {
            required: false,
            defaultValue: 'Employee'
        },
    };

    export class MeevoReportSelectDirective implements angular.IDirective {
        restrict = 'E';
        templateUrl = 'app/components/controls/meevo-report-select.directive.html';
        departments: any = null;

        scope = {
            label: '@?',
            options: '=',
            model: '=',
            layout: '@?',
            defaultValue: '=?',
            valueKey: '@?',
            disabled: "=?ngDisabled"
        };

        static factory(): angular.IDirectiveFactory {
            const directive = () => {
                return new MeevoReportSelectDirective();
            };

            directive.$inject = [];

            return directive;
        }

        constructor() {
        }

        link(scope: IMeevoReportSelectDirectiveScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) {
            scope.label = scope.label || scope.options ? scope.options.labelText : null;
            scope.layout = scope.layout || 'row';
            scope.url = null;
            scope.requestData = null;
            scope.required = true;
            scope.hideIfEmpty = false;

            switch (scope.options.reportControlEnumType) {
                case 30051:
                case 20024:
                    scope.valueKey = 'displayName';
                    break;
            }

            angular.extend(scope, dataTemplate[scope.options.parameters[0].name] || {});

            scope.valueKey = scope.valueKey || 'value';

            if (!scope.model)
                scope.model = scope.defaultValue || (scope.options && scope.options.values.length ? scope.options.values[0][scope.valueKey] : null);


            // MA045
            if (
                scope.options &&
                scope.options.displayName === 'DepartmentListEmployeeMover' &&
                scope.options.reportId === 103
            ) {
                scope.$watch(() => scope.options.values, (newValue) => {
                    scope.options.values = scope.options.values.filter(v => v.id)
                    if (scope.options.values && scope.options.values[0] && scope.options.values[0].hasOwnProperty('id')) {
                        this.departments = scope.options.values[0].id;
                    } else {
                        this.departments = '';
                    }

                    if (!scope.$parent.mainModel['hideAnalyze'] || newValue.length > 1) {
                        if (!newValue || newValue.length === 0) {
                            scope.$parent.mainModel['hideAnalyze'] = true;
                        } else {
                            scope.$parent.mainModel['hideAnalyze'] = false;
                        }
                        scope.required = false;
                    }
                }, true);

                scope.$watch(() => scope.$parent.mainModel['AnalyzeRetentionForDepartmentMA045'], (newValue) => {
                    if (!scope.$parent.mainModel['hideAnalyze']) {
                        scope.required = newValue;
                        scope.$parent.mainModel['Departments_TBL'] = newValue ? this.departments : null;
                    }
                });
            }
            // MA045

            //MA050
            if (scope.options.reportId === 63 && scope.defaultValue === undefined
                && scope.options && scope.options.parameters && scope.options.parameters[0]
                && scope.options.parameters[0]["default"] && scope.options.parameters[0]["default"]["value"]) {
                scope.defaultValue = scope.options.parameters[0]["default"]["value"];
            }

            if (scope.options.reportId === 84) {
                // MR130, add location id to criteria for service and product categories
                scope.requestData.criteria.locationList = [scope.$parent.locationId];
            }

            switch (scope.options.reportId) {
                // set layout type for mobile view
                case 1: // AQ020
                case 2: // AQ022
                case 96: // MR200
                    scope.mobileLayoutType = 'stacked';
                    break;
                case 60: // COMR010
                    scope.mobileLayoutType = 'stretched';
                    break;
            }
		}
    }

    angular.module('meevo.components.controls')
        .directive('meevoReportSelectDirective', MeevoReportSelectDirective.factory());
}
